/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RoleDto } from './roleDto';
import { SiteDto } from './siteDto';


export interface CustomerDto { 
    id?: number;
    accessCode?: string | null;
    employeeId?: string | null;
    username?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    phoneNumber?: string | null;
    onboarded?: boolean;
    acceptedTermsAndConditions?: boolean;
    acceptedContract?: boolean;
    acceptedMarketing?: boolean;
    role?: RoleDto;
    wallet?: string | null;
    lastLogin?: string | null;
    lastPasswordChange?: string | null;
    azureAdUPN?: string | null;
    azureAdUsername?: string | null;
    otp?: string | null;
    companyId?: number | null;
    sites?: Array<SiteDto> | null;
    unlockCode?: string | null;
    taxId?: string | null;
    terminationDate?: string | null;
    foodDiaryEnabled?: boolean;
    foodDiaryOptInDone?: boolean;
}

